import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (localStorage.theme === "dark") {
      document.documentElement.classList.add("dark")
    }
  }

  toggle() {
    document.documentElement.classList.toggle("dark")
    localStorage.theme = document.documentElement.classList.contains("dark") ? "dark" : "light"
  }
}
